import { Box } from '@mui/system';
import { FC } from 'react';

import { Spinner } from 'src/components/spinner';

import { styles } from './styles';

export const Loader: FC = () => (
    <Box css={styles.loaderWrapper}>
        <Spinner size="big" />
    </Box>
);
